import { ChangeEvent, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { onlineshopApiBaseUrl } from '../Filters';
import { useProductsFilter } from '../../../../../Context/ProductsFilterContext';
import Skeleton from 'react-loading-skeleton';
import { Select, Option } from '../../../../Select/Select';
import { useUser } from '../../../../../Context/UserContext';
import { ProductFilterOptionNode } from '../../../../../../Interface/ProductFilterOption';
import clsx from 'clsx';
import FilterWrapper from '../../components/FilterWrapper/FilterWrapper';
import FilterOption from '../../components/FilterOption/FilterOption';

const SortByFilter = ({ className }: { className?: string }) => {
  const { user } = useUser();
  const { filters, setSingleFilter } = useProductsFilter();

  const {
    data: sortByFilter,
    isPending,
    isFetching,
    isSuccess,
  } = useQuery<ProductFilterOptionNode[]>({
    queryKey: ['sort_by_Filter'],
    queryFn: async () => {
      const res = await axios.get(`${onlineshopApiBaseUrl}/sort-by-filter`);
      return res.data;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    placeholderData: (prev) => prev,
  });

  const userSpecificSortOptions = useMemo(() => {
    if (!isSuccess || !sortByFilter.length) return [];

    if (user?.id) {
      return sortByFilter;
    } else {
      return sortByFilter.filter(
        (option) => !option.name.toLowerCase().includes('price')
      );
    }
  }, [isSuccess, sortByFilter, user?.id]);


  const handleUpdateSortByFilter = (event: ChangeEvent<HTMLSelectElement>) => {
    setSingleFilter('sortBy', event.target.value);
  };

  if (isPending || isFetching)
    return (
      <Skeleton className="d-none d-lg-block" height="2em" width={'200px'} />
    );

  return (
    <>
      {/* Desktop */}
      <div className={clsx('d-none d-lg-flex align-items-center gap-2', className)}>
        <Select value={filters.sortBy ?? ''} onChange={handleUpdateSortByFilter}>
          <Option value={''}>Sort By</Option>
          {userSpecificSortOptions?.map(({ value, name }) => (
            <Option key={name} value={value}>
              {name}
            </Option>
          ))}
        </Select>
      </div>

      {/* Mobile */}
      <div className="d-lg-none w-100">
        <FilterWrapper
          label="sort by"
          isSuccess={isSuccess}
          isPending={isPending}
          isFetching={isFetching}
          resultsCount={userSpecificSortOptions.length}
          initialOpen={false}
          expandable={true}
          noBorderBottom
        >
          {userSpecificSortOptions.map(({ value, name }) => (
            <FilterOption
              key={value}
              mode="single"
              filterKey="sortBy"
              value={value}
              name={name}
            />
          ))}
        </FilterWrapper>
      </div>
    </>
  );
};

export default SortByFilter;
